import type { Theme } from '@mui/material';

export const styles = {
  chart: (theme: Theme) => ({
    height: '8.5rem',
    width: '8.5rem',

    [theme.breakpoints.up('xl')]: {
      height: '10rem',
      width: '10rem',
    },
  }),

  chartBig: (theme: Theme) => ({
    height: '11.5rem',
    width: '11.5rem',

    [theme.breakpoints.up('xl')]: {
      height: '14rem',
      width: '14rem',
    },
  }),

  centerText: {
    textAlign: 'center',
    top: '50%',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, -1.5rem)',
  },
};
